export const columns: TableColumn[] = [
    {
        Header: 'Sl.No',
        accessor: 'slno',
      },
      {
        Header: 'Batch Code',
        accessor: 'batch_code',
      },
      {
        Header: 'Batch GRN',
        accessor: 'batch_grn',
      },
      {
        Header: 'Manufacturing Date',
        accessor: 'manufacturing_date',
      },
      // {
      //   Header: 'Expiry Date',
      //   accessor: 'expiry_date',
      // },
      {
        Header: 'Lot Count',    
        accessor: 'lot_count',
      },
      {
        Header: 'Plate Type',    
        accessor: 'plateType',
      },
      {
        Header: 'Quantity',    
        accessor: 'quantity',
      },
      {
        Header: 'Status',    
        accessor: 'status',
      },
]

export const Lotcolumns: TableColumn[] = [
  {
      Header: 'Sl.No',
      accessor: 'slno',
    },
    {
      Header: 'Lot Code',
      accessor: 'lot_code',
    },
    {
      Header: 'Batch GRN',
      accessor: 'batch_grn',
    },
    {
      Header: 'Manufacturing Date',
      accessor: 'manufacturing_date',
    },
    // {
    //   Header: 'Expiry Date',
    //   accessor: 'expiry_date',
    // },
    {
      Header: 'Lot Count',    
      accessor: 'plate_count',
    },
    {
      Header: 'Plate Type',    
      accessor: 'passed_plate_count',
    },
    {
      Header: 'Quantity',    
      accessor: 'quantity',
    },
    {
      Header: 'Status',    
      accessor: 'inspection_status',
    },
]


export const Platecolumns: TableColumn[] = [
  {
      Header: 'Sl.No',
      accessor: 'slno',
    },
    {
      Header: 'Plate Serial No',
      accessor: 'serial_number',
    },
    {
      Header: 'Activity',
      accessor: 'activity',
    },
    {
      Header: 'Location',
      accessor: 'location',
    },
    // {
    //   Header: 'Expiry Date',
    //   accessor: 'expiry_date',
    // },
    {
      Header: 'Start Date',    
      accessor: 'manufacturing_date',
    },
    {
      Header: 'End Date',    
      accessor: 'expiry_date',
    },
    {
      Header: 'Started By',    
      accessor: 'started_by',
    },
    {
      Header: 'Completed By',    
      accessor: 'completed_by',
    },
    {
      Header: 'Status',    
      accessor: 'status',
    },
]

export const BatchWiseReconcilationColums: TableColumn[] = [
  {
    Header: 'BatchWiseReconcilationColums.Sl no',
    accessor: 'slno',
  },
  {
    Header: 'tableCommon.batch_code',
    accessor: 'batch_number',
  },
  {
    Header: 'BatchWiseReconcilationColums.Lot Count',
    accessor: 'lot_count',
  },
  {
    Header: 'BatchWiseReconcilationColums.Total Plate Count',
    accessor: 'plates_available',
  },
  {
    Header: 'BatchWiseReconcilationColums.Plates Used Count',    
    accessor: 'plates_used',
  },
  {
    Header: 'BatchWiseReconcilationColums.Remaining Plates Count',    
    accessor: 'remaining_plates_reconciliation',
  },
]

export const LotWiseReconcilationColums: TableColumn[] = [
  {
    Header: 'Sl.No',
    accessor: 'slno',
  },
  {
    Header: 'Lot Code',
    accessor: 'lot_code',
  },
  {
    Header: 'Total Plate Count',
    accessor: 'plates_availables',
  },
  {
    Header: 'Plates Used Count',    
    accessor: 'plates_used',
  },
  {
    Header: 'Remaining Plates Count',    
    accessor: 'remaining_plates',
  },
]

export const ActivityWiseReconcilationColums: TableColumn[] = [
  {
    Header: 'Sl.No',
    accessor: 'slno',
  },
  {
    Header: 'Lot Code',
    accessor: 'lot_code',
  },
  {
    Header: 'Plate Sampling',
    accessor: 'plate_sampling',
  },
  {
    Header: 'Active Air Sampling',
    accessor: 'air_sampling',
  },
  {
    Header: 'Passive Air Sampling',    
    accessor: 'passive_sampling',
  },
  {
    Header: 'Anaerobic Monitoring',    
    accessor: 'anaerobic_monitoring',
  },
  {
    Header: 'Nitrogen Monitoring',    
    accessor: 'nitrogen_monitoring',
  },
  {
    Header: 'Compressed Air Monitoring',    
    accessor: 'compressed_air_monitoring',
  },
  {
    Header: 'Raw Material Test',    
    accessor: 'sample_type_test',
  },
  {
    Header: 'Contact Plate Monitoring',    
    accessor: 'surface_monitoring',
  },
  {
    Header: 'Glove Port Monitoring',    
    accessor: 'glove_monitoring',
  },
  {
    Header: 'Personnel Monitoring',    
    accessor: 'personnel_monitoring',
  },
  {
    Header: 'Surface Monitoring- Swab Collection',    
    accessor: 'swab_collection',
  },
  {
    Header: 'Visual Inspection Failed',    
    accessor: 'visual_inspection_failed',
  },
  {
    Header: 'Plate Rejected',    
    accessor: 'plate_rejected',
  },
  {
    Header: 'Plate Discarded',    
    accessor: 'plate_discarded',
  },
  {
    Header: 'Exception Added',    
    accessor: 'exception_added',
  },
]

export const PlateWiseReconcilationColums: TableColumn[] = [
  {
    Header: 'Sl.No',
    accessor: 'slno',
  },
  {
    Header: 'Lot Code',
    accessor: 'lot_code',
  },
  {
    Header: 'Plate QR Generated',    
    accessor: 'plate_qr_generated',
  },
  {
    Header: 'Pending For QR Generation',    
    accessor: 'pending_for_qr_generated',
  },
]


interface TableColumn {
    Header: string;
    accessor: string;
  }
